function isPC() {
  return !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
}

function generateImageData(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.setAttribute('crossOrigin', 'anonymous');

    image.onload = function () {
      let w = image.naturalWidth;
      let h = image.naturalHeight;
      resolve({ image, w, h, url });
    }
    image.onerror = function () {
      reject({ url });
    }

    image.src = url;
  });
}

function camelCase(s) {
  return s.toLowerCase().replace(/-(.)/g, function (m, g) {
    return g.toUpperCase();
  });
} // Convert camel cased string to string seperated

function unCamelCase(s) {
  return s.replace(/([A-Z])/g, function (m, g) {
    return '-' + g.toLowerCase();
  });
}

function getStyle(element, styleName) {
  if (!element || !styleName) return null;

  const ieVersion = Number(document.documentMode);
  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = ieVersion < 9 ? 'styleFloat' : 'cssFloat';
  }

  if (ieVersion < 9) {
    try {
      switch (styleName) {
        case 'opacity':
          try {
            return element.filters.item('alpha').opacity / 100;
          } catch (e) {
            return 1.0;
          }
        default:
          return (element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null);
      }
    } catch (e) {
      return element.style[styleName];
    }
  } else {
    try {
      var computed = document.defaultView.getComputedStyle(element, '');
      return element.style[styleName] || computed ? computed[styleName] : null;
    } catch (e) {
      return element.style[styleName];
    }
  }
};